(function(root){
  'use strict';
  const asset=name=>root.DB_ASSETS[name];
  const PAPER={x:36,y:56,width:773,height:1099};
  function make(id,label,names,overviewHeight=1200){
    return Object.freeze({id,label,cover:asset(id+'-cover.webp'),thumb:asset(id+'-thumb.webp'),overview:asset(id+'-overview.webp'),overviewWidth:1200,overviewHeight,
      pages:Object.freeze(names.map((name,index)=>Object.freeze({name,src:asset(id+'-peek-'+(index+1)+'.webp'),width:index?842:850,height:index?1191:1200,viewBox:index?'0 0 842 1191':'36 80 773 1075'})))});
  }
  const EDITIONS=Object.freeze({
    original:make('original','Darts Babes Calendar 2027',['February','May','August','November','Cover']),
    xxl:make('xxl','XXL Calendar 2027',['Week 3','Week 4','Week 8','Week 31','Week 39','Cover'],1381)
  });
  function edition(id){if(!Object.hasOwn(EDITIONS,id))throw new RangeError('Unknown calendar media');return EDITIONS[id];}
  function dialogue(elapsed){return{question:elapsed>=1.15,answer:elapsed>=2.85,done:elapsed>=2.85};}
  const api={EDITIONS,PAPER,edition,dialogue,SLIDE_COUNT:3};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.DB_MEDIA=api;
})(typeof window!=='undefined'?window:globalThis);
